<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qMb49H/tc-custom/9780310412762.jpg?1724781541886" alt="This image is the cover for the book Protection for Hire, Protection for Hire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Protection for Hire, Protection for Hire
      </h1>
      <p class="bookDescription body article font2">
        <p>Tessa Lancaster’s skills first earned her a position as an enforcer in her Uncle Teruo’s Japanese Mafia gang. Then they landed her in prison for a crime she didn’t commit. Now, three months after her release, Tessa’s abilities have gained her a job as bodyguard for wealthy socialite Elizabeth St. Amant and her three-year-old son. But there’s a problem or two … or three …. There’s Elizabeth’s abusive husband whose relentless pursuit goes deeper than mere vengeance. There’s Uncle Teruo, who doesn’t understand why Tessa’s new faith as a Christian prevents her from returning to the yakuza. And then there’s Elizabeth’s lawyer, Charles Britton, who Tessa doesn’t know is the one who ensured that she did maximum time behind bars. Now Tessa and Charles must work together in order to protect their client, while new truths emerge and circumstances spiral to a deadly fever pitch. Factor in both Tessa’s and Charles’s families and you’ve got some wild dynamics—and an action-packed, romantic read as Tessa and Charles discover the reality of being made new in Christ.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Camy Tang
      </h2>
      
      <p class="authorDescription body article"><P>Camy Tang grew up in Hawaii and now lives in San Jose, California with her engineer husband and rambunctious dog. She was a biologist researcher, but these days she is surgically attached to her computer, writing full-time. In her spare time, she is a staff worker for her church youth group, and she leads one of the worship teams for Sunday service. She won the Carol Book of the Year award with her novel <I>Sushi for One? </I><I>Follow Camy online at </I><I><A href="http://www.camytang.com/" data-mce-href="http://www.camytang.com/">www.camytang.com</A></I><I></I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?987100a0